import React from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';

// project import
import PharoIconSvg from 'assets/pharo-logo.svg';
import { ThemeMode } from 'config';

// ==============================|| HEADER CONTENT - Pharo Logo ||============================== //

const env = import.meta.env.MODE || 'development'; // Default to 'production' if not set

export default function PharoIcon() {
  const theme = useTheme();
  const navigate = useNavigate();
  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

  // Define badge color based on environment
  let badgeColor = '';
  let envName = '';
  if (env === 'devlocal') {
    badgeColor = 'red';
    envName = 'LOCAL';
  } else if (env === 'development') {
    badgeColor = 'orange';
    envName = 'DEV';    
  } else if (env === 'tst') {
    badgeColor = 'blue';
    envName = 'TST';
  } else if (env === 'staging') {
    badgeColor = 'green';
    envName = 'STG';
  }

  const showBadge = env !== 'production';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '50px',
        height: '50px',
        border: '0px',
        borderRadius: '8px',
        position: 'relative',
        backgroundColor: theme.palette.mode === ThemeMode.DARK ? '#e2e1e1' : 'transparent',
        padding: theme.palette.mode === ThemeMode.DARK ? '4px' : '0px',
      }}
      // onClick={() => {navigate('/orders'); }}
    >
      <img src={PharoIconSvg} alt="Pharo Logo" width="50" height="50" />
      {showBadge && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: '0px',
            bgcolor: badgeColor,
            color: 'white',
            px: 0.5,
            borderRadius: '4px',
            fontSize: '0.7rem',
            fontWeight: 'bold',
            lineHeight: 1.2,
            zIndex: 1,
          }}
        >
          {envName.toUpperCase()}
        </Box>
      )}
    </Box>
  );
}
